export default __webpack_public_path__ + "static/media/deposit-card.36aef71a.svg";